module.exports = __webpack_public_path__ + "static/media/lumbering27.e77d715e.jpg";